import { getConfig } from '@/config';

export const debugLog = (...args) => {
  if (getConfig("ENABLE_DEBUG")) {
    console.log(...args);
  }
};

export const debugWarn = (...args) => {
  if (getConfig("ENABLE_DEBUG")) {
    console.warn(...args);
  }
};

export const debugError = (...args) => {
  if (getConfig("ENABLE_DEBUG")) {
    console.error(...args);
  }
};